<footer class="bg-footer" style="margin-top: 100px">
  <div class="container grid-container py-5">
    <div class="logo">
      <a class="icon-link" [routerLink]="selectedLanguage.code === 'en' ? '/' : '/' + selectedLanguage.code ">
        <img src="/assets/images/footer/footer.svg" alt="GrammarInLogo" />

        <img src="assets/images/favicon.png" width="1" height="1" style="height: 1px; width: 1px" />
        <img src="assets/images/side bar icons/grammarin-logo.svg" width="1" height="1"
          style="height: 1px; width: 1px" />
      </a>

      <p class="mt-4 me-2 p-grammarin">

        {{ "footer.description" | translate }}
      </p>
      <ul class="list-unstyled">
        <li class="p-grammarin add-email"></li>
        <li class="p-grammarin add-email">
          <app-icons-free-tools name="emailIcon" />
          <a href="mailto:support@grammarin.com" style="text-decoration: none; ">
            support&#64;grammarin.com</a>
        </li>
      </ul>


      <div class="dropdown-container" #dropdownRef>
        <button class="menu-btn nav-item dropdown" (click)="toggleMenu()">
          <img [src]="selectedLanguage.icon" alt="Selected language icon " class="me-1" />
          {{ selectedLanguage.name }}

          <app-icons-free-tools name="dropdownIcon" class="drop-icon" [hidden]="!shouldShowLanguageDropdown()" />
        </button>

        <div class="mt-2" *ngIf="shouldShowLanguageDropdown()">
          <div id="menuContent" class="menu-content scrollable " [ngClass]="{ 'show-menu': isMenuOpen }">
            <a *ngFor="let lang of languages" class="" href="javascript:void(0)" (click)="selectLanguage(lang)">
              <img [src]="lang.icon" alt="drop-img" class="flag me-2" />
              <span class="lang-names">{{ lang.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="links">
      <div>

        <p class="heading">{{ "footer.company" | translate }}</p>
        <ul class="list-unstyled mt-md-4">
          <li>
            <a href=" /about-us">

              {{ "footer.about" | translate }}
            </a>
          </li>
          <li>
            <a href="/contact-us">

              {{ "footer.contact" | translate }}
            </a>
          </li>

          <li>
            <a href="/handbook">

              {{ "footer.handbook" | translate }}
            </a>
          </li>

          <li>
            <a href="/pricing">

              {{ "footer.pricing" | translate }}
            </a>
          </li>
          <li>
            <a href="/help-center">

              {{ "footer.help" | translate }}
            </a>
          </li>
        </ul>
      </div>
      <div>
        <p class="heading">

          {{ "footer.privacy" | translate }}
        </p>
        <ul class="list-unstyled mt-md-4">
          <li>
            <a href="https://www.grammarin.com/terms-conditions">

              {{ "footer.terms" | translate }}
            </a>
          </li>

          <li>
            <a href="https://www.grammarin.com/privacy-policy">

              {{ "footer.privacyPolicy" | translate }}
            </a>
          </li>
          <li>
            <a href="https://www.grammarin.com/blog/ ">
              {{ "footer.blog" | translate }}</a>
          </li>
        </ul>
      </div>

      <div>
        <p class="heading">

          {{ "footer.tools" | translate }}
        </p>
        <ul class="list-unstyled mt-md-4">
          <li>
            <a
              [routerLink]="selectedLanguage.code === 'en' ? '/grammar-checker' : '/' + selectedLanguage.code + '/grammar-checker'">

              {{ "footer.grammarChecker" | translate }}
            </a>
          </li>
          <li>
            <a href="/punctuation-checker">

              {{ "footer.punctuationChecker" | translate }}
            </a>
          </li>
          <li>
            <a href="/plagiarism-checker">

              {{ "footer.plagiarismChecker" | translate }}
            </a>
          </li>
          <li>
            <a href="/paraphrasing-tool">

              {{ "footer.paraphrasingTool" | translate }}
            </a>
          </li>
          <li>
            <a href="/text-summarizer">

              {{ "footer.textSummarizer" | translate }}
            </a>
          </li>

          <li>
            <a href="/ai-content-detector">

              {{ "footer.aiContentDetector" | translate }}
            </a>
          </li>
          <li>
            <a href="/article-rewriter">

              {{ "footer.articleRewriter" | translate }}
            </a>
          </li>
          <li>
            <a href="/sentence-checker">

              {{ "footer.sentenceChecker" | translate }}
            </a>
          </li>
          <li>
            <a href="/essay-checker">

              {{ "footer.essayChecker" | translate }}
            </a>
          </li>
          <li>
            <a href="/online-proofreader">

              {{ "footer.onlineProofreader" | translate }}
            </a>
          </li>
          <li>
            <a href="/ai-writing-tools">

              {{ "footer.aiWritingTools" | translate }}
            </a>
          </li>
        </ul>
      </div>
      <div>
        <p class="heading">

          {{ "footer.aiTools" | translate }}
        </p>
        <ul class="list-unstyled mt-md-4">
          <li>
            <a href="/ai-job-description">

              {{ "footer.aiJobDescription" | translate }}
            </a>
          </li>
          <li>
            <a href="/ai-business-plan">

              {{ "footer.aiBusinessPlan" | translate }}
            </a>
          </li>
          <li>
            <a href="/ai-summarizer">

              {{ "footer.aiSummarizer" | translate }}
            </a>
          </li>
          <li>
            <a href="/ai-paragraph-generator">

              {{ "footer.aiParagraphGenerator" | translate }}
            </a>
          </li>
          <li>
            <a href="/ai-letter-writer">

              {{ "footer.aiLetterWriter" | translate }}
            </a>
          </li>
          <li>
            <a href="/ai-article-writer">

              {{ "footer.aiArticleWriter" | translate }}
            </a>
          </li>

          <li>
            <a href="/grading">

              {{ "footer.ieltsGrading" | translate }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="container py-4">
    <div class="content-wrapper">
      <div class="text">
        <p class="text-white">
          &copy; {{ dateRange }}
          <a href="https://www.grammarin.com" class="text-white">

            {{ "footer.grammarIn" | translate }} </a>.

          {{ "footer.rights" | translate }}
        </p>
      </div>
      <div class="social-media-links">
        <ul class="list-unstyled d-flex" style="list-style-type: none; padding: 0; margin: 0">
          <li class="me-1">
            <a href="https://www.facebook.com/GrammarIn" target="_blank" rel="noopener noreferrer">
              <app-icons-free-tools name="fbIcon" class="hower" />
            </a>
          </li>
          <li class="me-1">
            <a href="https://www.instagram.com/grammar_in/" target="_blank" rel="noopener noreferrer">
              <app-icons-free-tools name="instaIcon" class="hower" />
            </a>
          </li>
          <li class="me-1">
            <a href="https://twitter.com/GrammarIn2" target="_blank" rel="noopener noreferrer">
              <app-icons-free-tools name="twitterIcon" class="hower" />
            </a>
          </li>
          <li class="me-1">
            <a href="https://www.linkedin.com/company/grammarin" target="_blank" rel="noopener noreferrer">
              <app-icons-free-tools name="linedinIcon" class="hower" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>

<router-outlet></router-outlet>